export function export2Excel(filename, columns, list, merges) {
  var name = filename || '数据列表'
  var merges2 = merges || []
  require.ensure([], () => {
    const {
      export_json_to_excel
    } = require('./Export2Excel');
    let tHeader = []
    let filterVal = []

    if (!columns) {
      return;
    }
    columns.forEach(item => {
      tHeader.push(item.title)
      filterVal.push(item.key)
    })
    const data = list.map(v => filterVal.map(j => v[j]))
    export_json_to_excel(tHeader, data, name, merges2);
  })
}

export function exportTable2Excel(table_id, filename) {
  var name = filename || '数据列表'
  require.ensure([], () => {
    const {
      export_table_to_excel
    } = require('./Export2Excel');
    export_table_to_excel(table_id, name);
  })
}

export function exportMultiHeader2Excel(filename, columns, list, merges, multiHeader) {
  var name = filename || '数据列表'
  var merges2 = merges || []
  require.ensure([], () => {
    const {
      export_json_to_excel_with_multi_header
    } = require('./Export2Excel');
    let tHeader = []
    let filterVal = []

    if (!columns) {
      return;
    }
    columns.forEach(item => {
      tHeader.push(item.title)
      filterVal.push(item.key)
    })
    const data = list.map(v => filterVal.map(j => v[j]))
    export_json_to_excel_with_multi_header(tHeader, data, name, merges2, multiHeader);
  })
}



// WEBPACK FOOTER //
// ./src/assest/utils/util.js